/**
 * @desc 红人管理-分页查询
 */
const URL = "/rantion-kol";
import http, { updateResponse } from "@/http";
export type Response = defs.kol.ResponseDto<defs.kol.IPage<defs.kol.CelebrityResponseDto>>;
export function request(
  params: API.kol.celebrity.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/kol/celebrity/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
